import { render, staticRenderFns } from "./ReminderQuestion.vue?vue&type=template&id=0451da07&"
import script from "./ReminderQuestion.vue?vue&type=script&lang=js&"
export * from "./ReminderQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ReminderQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports